import { AuthHelper } from "helpers/auth-helper";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { string } from "yup";
import { toast } from "react-toastify";
import { CustomToast } from "components";

interface AuthState {
  user: any;
  isLoading: boolean;
  accessToken: string | null;
  userProfileData: any;
}

const initialState = {
  user: null,
  isLoading: false,
  accessToken: null,
  userProfileData: null,
} as AuthState;

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserCredentials: (state, { payload }) => {
      const { ...restPayload } = payload;
      state.user = restPayload.user;
      // state.accessToken = access_token;
      state.isLoading = false;
    
      AuthHelper.setCredentials("bettybet_user", restPayload.user, false);
    },
    setUserProfileData: (state, { payload }) => {
      const { ...restPayload } = payload;
      state.userProfileData = restPayload.userProfileData;
      // state.accessToken = access_token;
      state.isLoading = false;
      // AuthHelper.setCredentials("bettybet_user_profile_data", restPayload.user, false);
    },
    setUserToken: (state, { payload }) => {
      const { access_token, ...restPayload } = payload;
      // state.user = restPayload;
      state.accessToken = access_token;
      state.isLoading = false;
      AuthHelper.setCredentials("access_token", payload.access_token, true);
    },
    logOut: (state) => {
      state.user = null;
       state.userProfileData = null;
      state.isLoading = false;
      state.accessToken = null;
     
      AuthHelper.clearCredentials();
      window.location.href = "/app/home";
      window.location.reload();
      console.log("logged out");
    },
  },
});

export const { setUserCredentials, setUserToken, logOut, setUserProfileData } =
  authSlice.actions;
export default authSlice.reducer;

export const useSelectUserDetails = (
  state: RootState
): any | null | undefined => state.auth.user;
export const useSelectAccessToken = (
  state: RootState
): any | null | undefined => state.auth.accessToken;

export const useSelectUserProfileDetails = (
  state: RootState
): any | null | undefined => state.auth.userProfileData;